"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEnvironment = exports.isEnvironment = exports.Environment = void 0;
exports.Environment = {
    DEVELOPMENT: 'development',
    CI: 'ci',
    TESTING: 'testing',
    ACCEPTANCE: 'acceptance',
    PRODUCTION: 'production',
};
const isEnvironment = (value) => Object.values(exports.Environment).some((environment) => environment === value);
exports.isEnvironment = isEnvironment;
const parseEnvironment = (value) => {
    const lowercaseValue = value.toLowerCase();
    return (0, exports.isEnvironment)(lowercaseValue) ? lowercaseValue : undefined;
};
exports.parseEnvironment = parseEnvironment;
